import { WmsStockInfo } from '../types';

export default function StockUpdatedAt({ stock }: { stock?: WmsStockInfo | null }) {
  if (!stock?.wms_available) return null;
  const updatedAt = stock.stock_updated_at ? new Date(stock.stock_updated_at) : null;
  if (!updatedAt || Number.isNaN(updatedAt.getTime())) {
    return <p className="text-xs text-gray-500">Data aggiornamento non disponibile</p>;
  }
  const label = updatedAt.toLocaleString('it-IT', {
    timeZone: 'Europe/Rome', day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
  return (
    <p className="text-xs text-gray-500" title="Ultimo aggiornamento della giacenza nel WMS · ora italiana">
      Aggiornata il <time dateTime={updatedAt.toISOString()}>{label}</time>
    </p>
  );
}
